"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _checkTypes = _interopRequireDefault(require("check-types"));

var _semanticUiReact = require("semantic-ui-react");

var _moment = _interopRequireDefault(require("../../../lib/moment"));

var _isNative = _interopRequireDefault(require("../../../lib/is-native"));

var _Fonts = require("../../00_environment/Fonts");

var _Button = _interopRequireDefault(require("../../01_atoms/Button"));

var _DualPanePage = _interopRequireDefault(require("../../01_atoms/DualPanePage"));

var _LoadingPlaceHolder = _interopRequireDefault(require("../../01_atoms/LoadingPlaceHolder"));

var _DefaultScreen = _interopRequireDefault(require("../../02_molecules/DefaultScreen"));

var _RidesList = _interopRequireDefault(require("../../02_molecules/RidesList"));

var _PlaceHolder = _interopRequireDefault(require("../../02_molecules/PlaceHolder"));

var _TicketDetailsCardWidget = _interopRequireDefault(require("../../02_molecules/TicketDetailsCardWidget"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var DualPaneGenericTripsListPage = /*#__PURE__*/function (_Component) {
  _inherits(DualPaneGenericTripsListPage, _Component);

  var _super = _createSuper(DualPaneGenericTripsListPage);

  function DualPaneGenericTripsListPage() {
    var _this;

    _classCallCheck(this, DualPaneGenericTripsListPage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      selectedTrip: null
    };
    return _this;
  }

  _createClass(DualPaneGenericTripsListPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!(0, _isNative["default"])() && _checkTypes["default"].nonEmptyString(window.location.hash)) {
        var id = window.location.hash.substr(1);

        if (_checkTypes["default"].nonEmptyString(id)) {
          var rides = this.props.rides;
          var selectedRide = rides.find(function (r) {
            return r.id === id;
          });

          if (selectedRide) {
            this.setState({
              selectedTrip: selectedRide
            });
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          sdk = _this$props.sdk,
          origin = _this$props.origin,
          destination = _this$props.destination,
          date = _this$props.date,
          rides = _this$props.rides,
          isReturn = _this$props.isReturn,
          _this$props$onTripSel = _this$props.onTripSelect,
          onTripSelect = _this$props$onTripSel === void 0 ? function () {} : _this$props$onTripSel,
          _this$props$onBack = _this$props.onBack,
          onBack = _this$props$onBack === void 0 ? function () {} : _this$props$onBack,
          numberOfPassengers = _this$props.numberOfPassengers,
          isOneWayTrip = _this$props.isOneWayTrip;
      var _this$state$selectedT = this.state.selectedTrip,
          selectedTrip = _this$state$selectedT === void 0 ? null : _this$state$selectedT;
      var _sdk$i18n = sdk.i18n,
          translationManager = _sdk$i18n.translationManager,
          translatorForNamespace = _sdk$i18n.translatorForNamespace;
      var t = translatorForNamespace('GenericTripListPageUI');

      var title = /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'inline',
          marginLeft: 5
        }
      }, "".concat(isReturn ? t('Return') : t('Outbound'), ": "), sdk.terminals.nameFromId(origin), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
        name: "arrow right",
        style: {
          display: 'inline',
          marginLeft: 5
        }
      }), "".concat(sdk.terminals.nameFromId(destination)), "\xA0\xA0\xA0");

      var content = null; // Set moment locale

      _moment["default"].locale(translationManager.getCurrentLanguage());

      if (!rides) {
        content = /*#__PURE__*/_react["default"].createElement(_LoadingPlaceHolder["default"], null);
      } else if (_checkTypes["default"].emptyArray(rides)) {
        content = /*#__PURE__*/_react["default"].createElement(_PlaceHolder["default"], {
          title: t('No rides found for this trip'),
          icon: "bus",
          content: /*#__PURE__*/_react["default"].createElement(_Button["default"], {
            onClick: onBack
          }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
            name: "arrow left",
            style: {
              display: 'inline',
              lineHeight: (0, _Fonts.withDefaultButtonFont)({}).fontSize,
              marginRight: 5
            }
          }), /*#__PURE__*/_react["default"].createElement("span", null, t('Try other dates')))
        });
      } else {
        // Display them
        content = /*#__PURE__*/_react["default"].createElement(_DualPanePage["default"], {
          leftComponent: function leftComponent() {
            return /*#__PURE__*/_react["default"].createElement(_RidesList["default"], {
              rides: rides,
              numberOfPassengers: numberOfPassengers,
              onRideClick: function onRideClick(trip) {
                if (!(0, _isNative["default"])()) {
                  window.location.hash = trip.id;
                }

                _this2.setState({
                  selectedTrip: trip
                });
              },
              translator: t,
              title: title,
              onBack: onBack
            });
          },
          rightComponent: selectedTrip ? function (_ref) {
            var scrollTop = _ref.scrollTop;
            return /*#__PURE__*/_react["default"].createElement(_TicketDetailsCardWidget["default"], {
              sdk: sdk,
              trip: selectedTrip,
              focusedLeftItemId: "ride_".concat(selectedTrip.id),
              onConfirm: function onConfirm() {
                return onTripSelect(selectedTrip);
              },
              nPassengers: numberOfPassengers,
              translator: t,
              locale: translationManager.getCurrentLanguage(),
              origin: origin,
              destination: destination,
              isReturn: isReturn,
              isOneWayTrip: isOneWayTrip,
              scrollTop: scrollTop
            });
          } : null
        });
      }

      return /*#__PURE__*/_react["default"].createElement(_DefaultScreen["default"], {
        title: title,
        onBack: onBack,
        topBarRightChildren: /*#__PURE__*/_react["default"].createElement("span", {
          style: {
            marginRight: 20
          }
        }, (0, _moment["default"])(date).format('DD MMM YYYY'))
      }, content);
    }
  }]);

  return DualPaneGenericTripsListPage;
}(_react.Component);

exports["default"] = DualPaneGenericTripsListPage;